<div class="checkbox">
  <input
    type="checkbox"
    class="checkbox__input"
    id="{{ componentId }}"
    [(ngModel)]="val"
    (change)="trigger()"
    [disabled]="isDisabled ? '' : null"
  />
  <basic-label
    class="label-basic"
    [componentId]="prop"
    [displayText]="displayText"
    [inputClass]="'checkbox__label ' + inputClass"
  ></basic-label>
</div>
